// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSChart/Magnifier/index.less
// module id = 981
// module chunks = 42